import React from 'react';

// A part of the app somebody's login does not include.
//
// One component and one sentence, because there are two ways into most of these: the page itself,
// and the same page embedded in a client's tab. The route was gated and the tab was not — so the
// Uncoded tab on a client fetched a list the server refused, the rejection went nowhere, and the
// tab sat on "Loading…" for ever. A spinner is the worst possible answer to "you do not have
// access": it says the app is working on it, so somebody waits, then reloads, then reports it as
// broken.
//
// Said as a tick box rather than as a refusal. Nobody here is being kept out of anything — the
// permissions exist so a login can be narrow, and the useful thing to tell somebody is who turns
// it on.
// The one sentence, wherever something is locked — this card, a client tab reached by a link, a
// button greyed for want of a permission. They said four different things ("ask Zev", "ask the
// owner", "the owner can tick it under Team", "No access").
export const LOCK_HOW = 'Ask the owner — it’s a tick box against your login under Staff.';
export const lockMessage = (what) => `${what} isn’t part of your access. ${LOCK_HOW}`;

export default function Gated({ ok, what, children }) {
  if (ok) return children;
  return (
    <div className="card" style={{ padding: 24, maxWidth: 520, marginTop: 20 }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{what} isn’t part of your access</div>
      <p className="hint hint-base" style={{ margin: 0 }}>{LOCK_HOW}</p>
    </div>
  );
}
